module.exports = __webpack_public_path__ + "img/bone.dec1c71b.png";